<template>
  <div class="w-full h-full relative">
    <!-- -->
    <div class="w-full h-full hide-scroll pb-40">
      <!-- <div class="p-2 text-base">
          Upgrade to Gold to see people who are intersted in you
        </div> -->

      <div class="w-full">
        <div class="w-full grid md:grid-cols-3 grid-cols-2 md:gap-3 gap-5 pt-5">
          <!-- item -->

          <!-- item -->
          <div
            class="item-like md:h-[220px] h-[250px] relative"
            v-for="(item, index) in renderListFriendNews"
            :key="index"
            @click="onClickShowDetailFriendChat(item)"
          >
            <div
              class="image-item"
              :style="`background-image: url('${item.profiles?.avatars[0]?.meta.url}');`"
            ></div>
            <div class="overlay"></div>
            <div class="absolute bottom-0 p-3 left-0 text-left text-white">
              <div
                :title="item.fullname"
                class="text-base font-semibold w-[100px] text-ellipsis overflow-hidden whitespace-nowrap"
              >
                {{ item.fullname }}
              </div>
              <div class="text-sm flex items-center" v-if="item.onlineNow">
                <img
                  src="../../assets/icon_svg/ic_online.svg"
                  class="mr-2"
                  width="10"
                />
                <div>Active today</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tab-friend",

  data() {
    return {
      imageDefault: require("../../assets/icon_svg/60e6c99d818ebf0100a9c18e_3.jpeg"),
    };
  },

  computed: {
    renderListFriendNews() {
      debugger;
      return this.$store.state.messageModule.listFriends;
    },
  },

  mounted() {},

  methods: {
    onClickShowDetailFriendChat(val) {
      this.$emit("onShowDetailFriendChat", val);
    },
  },
};
</script>

<style lang="scss">
.item-like {
  width: 100%;
  display: flex;
  justify-content: center;
  border-radius: 20px;
  overflow: hidden;
}

.image-item {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 20px;
  transition: 0.3s;
  cursor: pointer;
}
.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%; /* Adjust as needed */
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.719),
    rgba(0, 0, 0, 0)
  ); /* Gradient from black to transparent */
  pointer-events: none; /* Ensure the overlay does not block interactions */
}
.image-item:hover {
  transform: scale(1.1);
}
</style>
